import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../../api/axios';

const MODULES = [
  { to: '/admin/members',    icon: 'fas fa-id-card',         label: 'Members',    color: '#1B3A6B' },
  { to: '/admin/committee',  icon: 'fas fa-users',           label: 'Committee',  color: '#C0392B' },
  { to: '/admin/events',     icon: 'fas fa-calendar-alt',    label: 'Events',     color: '#16a085' },
  { to: '/admin/gallery',    icon: 'fas fa-images',          label: 'Gallery',    color: '#8e44ad' },
  { to: '/admin/news',       icon: 'fas fa-newspaper',       label: 'News',       color: '#e67e22' },
  { to: '/admin/milestones', icon: 'fas fa-flag',            label: 'Milestones', color: '#2980b9' },
  { to: '/admin/documents',  icon: 'fas fa-file-alt',        label: 'Documents',  color: '#27ae60' },
  { to: '/admin/faq',        icon: 'fas fa-question-circle', label: 'FAQ',        color: '#7f8c8d' },
  { to: '/admin/content',    icon: 'fas fa-edit',            label: 'Content',    color: '#c0392b' },
  { to: '/admin/media',      icon: 'fas fa-photo-video',     label: 'Media',      color: '#8e44ad' },
];

export default function Dashboard() {
  const [stats, setStats] = useState({});

  useEffect(() => {
    Promise.allSettled([
      api.get('/members').then(r => ({ members: r.data.length })),
      api.get('/committee').then(r => ({ committee: r.data.length })),
      api.get('/events').then(r => ({ events: r.data.length })),
      api.get('/news?limit=1').then(r => ({ news: r.data.total })),
    ]).then(results => {
      const s = {};
      results.forEach(r => r.status === 'fulfilled' && Object.assign(s, r.value));
      setStats(s);
    });
  }, []);

  return (
    <div>
      <div className="mb-4">
        <h4 className="fw-bold mb-1">Dashboard</h4>
        <p className="text-muted small">Welcome to the MNCW admin panel. Manage your website content below.</p>
      </div>

      <div className="row g-3 mb-4">
        {[
          { label: 'Members', value: stats.members ?? '—', icon: 'fas fa-id-card', color: '#1B3A6B' },
          { label: 'Committee Members', value: stats.committee ?? '—', icon: 'fas fa-users', color: '#C0392B' },
          { label: 'Events', value: stats.events ?? '—', icon: 'fas fa-calendar-alt', color: '#16a085' },
          { label: 'News Articles', value: stats.news ?? '—', icon: 'fas fa-newspaper', color: '#8e44ad' },
        ].map(s => (
          <div key={s.label} className="col-sm-6 col-xl-3">
            <div className="card border-0 shadow-sm">
              <div className="card-body d-flex align-items-center gap-3">
                <div className="rounded p-3 text-white" style={{ background: s.color }}>
                  <i className={s.icon}></i>
                </div>
                <div>
                  <div className="h4 fw-bold mb-0">{s.value}</div>
                  <div className="text-muted small">{s.label}</div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      <h6 className="text-muted small text-uppercase mb-3 fw-bold">Manage Content</h6>
      <div className="row g-3">
        {MODULES.map(m => (
          <div key={m.to} className="col-sm-6 col-md-4 col-lg-3">
            <Link to={m.to} className="card border-0 shadow-sm text-decoration-none h-100">
              <div className="card-body text-center py-4">
                <div className="rounded-circle d-flex align-items-center justify-content-center mx-auto mb-3 text-white" style={{ width: '48px', height: '48px', background: m.color }}>
                  <i className={m.icon}></i>
                </div>
                <div className="fw-bold text-dark small">{m.label}</div>
              </div>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
}
